import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../utils/style.js';
export const blockStyles = {
    primary: 'bg-white text-primary-text',
    secondary: 'bg-primary-main text-white',
    gray: 'bg-main-divider text-primary-text',
    transparent: 'bg-transparent text-primary-text',
    '': '',
};
export const BlockWrapper = JSX(({ className, version = 'primary', isTheme = true, defaultPadding = 'p-xl', padding, block, tag = 'section', role, children, style: inlineStyles, }) => {
    const Tag = tag;
    const isGroup = version && isTheme;
    return (_jsx(Tag, { className: style('@container font-sans', {
            group: isGroup,
        }, blockStyles[version], padding || defaultPadding, className), ...(isGroup ? { 'data-ver': version } : {}), ...(block?.anchor ? { id: block.anchor } : {}), role: role, style: inlineStyles, children: children }));
});
//# sourceMappingURL=BlockWrapper.js.map